// ──────────────────────────── Routes ────────────────────────────

// /admin is now a live route (security module). /help remains a dead route.

// bugs, kept as literals at call sites, tolerated by the validator's DEAD_ROUTES set.

export const ROUTES = {
  APP: {
    AUTH_LOGIN: "/auth/login",
    FORGOT_PASSWORD: "/auth/forgot-password",
    POINTAGE_HASH: "/auth/pointage/$hash",
    HOME: "/",
    MENTIONS_LEGALES: "/mentions-legales",
    PARAMETRES: "/parametres",
    POLITIQUE_CONFIDENTIALITE: "/politique-confidentialite",
    PROFILE: "/profile",
    RH: "/rh",
  },
} as const;
